import { useTranslation } from 'react-i18next';
import useBranch from '../../../../data/branch/useBranch';
import { Button } from '../../../../styled-components/components/Button';
import { Column, Columns } from '../../../../styled-components/components/Columns';
import InfoBox from '../../../../styled-components/components/InfoBox';
import { ShallowPanelBody } from '../../../../styled-components/components/Panel/ShallowPanel';
import {
  SeparatorList,
  SeparatorListItem,
} from '../../../../styled-components/components/SeparatorList';
import { StackMedium } from '../../../../styled-components/components/Stack';
import { Text } from '../../../../styled-components/components/Text';
import { VStack } from '../../../../styled-components/components/VStack';
import type { CreateVehiclePanels } from './utils';

interface SelectCreateMethodProps {
  navigatePanel: (panel: CreateVehiclePanels) => void;
}

export const SelectCreateMethod = ({ navigatePanel }: SelectCreateMethodProps) => {
  const { t } = useTranslation(['createVehiclePanel', 'common']);

  const [branch] = useBranch();
  const notAuthorized = !branch?.resellerFor.length;

  return (
    <ShallowPanelBody>
      <SeparatorList $spacing={3}>
        <SeparatorListItem>
          <Columns $spacing={2} $valign="center">
            <Column $grow>
              <VStack $spacing={0.5}>
                <Text $weight="bold">{t('stockVehicle', { ns: 'createVehiclePanel' })}</Text>
                <Text $tone="alt" $size="xsmall">
                  {t('stockVehicleDescription', { ns: 'createVehiclePanel' })}
                </Text>
              </VStack>
            </Column>
            <Column $noShrink>
              <Button
                $tone="primary"
                onClick={() => navigatePanel('REGISTERED')}
                title={t('select', { ns: 'common' })}
              >
                {t('select', { ns: 'common' })}
              </Button>
            </Column>
          </Columns>
        </SeparatorListItem>
        <SeparatorListItem>
          <StackMedium>
            <Columns $spacing={2} $valign="center">
              <Column $grow>
                <VStack $spacing={0.5}>
                  <Text $weight="bold">{t('orderVehicle', { ns: 'createVehiclePanel' })}</Text>
                  <Text $tone="alt" $size="xsmall">
                    {t('orderVehicleDescription', { ns: 'createVehiclePanel' })}
                  </Text>
                </VStack>
              </Column>
              <Column $noShrink>
                <Button
                  disabled={notAuthorized}
                  $tone="primary"
                  onClick={() => navigatePanel('ORDER')}
                  title={t('select', { ns: 'common' })}
                >
                  {t('select', { ns: 'common' })}
                </Button>
              </Column>
            </Columns>
          </StackMedium>
          {notAuthorized && (
            <StackMedium>
              <InfoBox>{t('unauthorizedRetailer', { ns: 'createVehiclePanel' })}</InfoBox>
            </StackMedium>
          )}
        </SeparatorListItem>
      </SeparatorList>
    </ShallowPanelBody>
  );
};
